module.exports = __webpack_public_path__ + "static/img/LANCASTER_MAPLE.205e317.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/LANCASTER_MAPLE.jpg
// module id = J146
// module chunks = 0